<template>
  <clp-dialog :show=this.bool.showDialog>
    <clp-confirmation
        page="sravni"
        :step='this.str.step'
        :loaderType='this.str.loaderType'
        :msgAlert='this.str.msgAlert'
        :confirmAvbl='this.bool.codeCheckAvbl'
        @closeDialog="this.bool.showDialog = false"
        @numbersInserted="numbersInserted"
        @checkNumbers="checkNumbers"
        @sendAgain="fetchCode"
    />
  </clp-dialog>

  <clp-dialog :show=this.bool.showErrorDialog>
    <clp-error
        page="sravni"
        :type=this.str.errorDialogType
        :descr="this.errors[1]"
        @closeDialog="this.bool.showErrorDialog = false"
    />
  </clp-dialog>

  <div class="page page--sravni container container--sravni">
    <clp-preview
        :short=this.bool.previewPassed
        @wrap="this.bool.previewPassed=true"
    />
    <div class="inline-alert inline-alert--sravni mb20" v-show="this.bool.showInlineAlert && this.bool.previewPassed">
      <clp-error
          parent="inline_alert"
          page="sravni"
          :type=this.str.errorDialogType
          :descr="this.errors[1]"
          @closeAlert="this.bool.showInlineAlert = false"
      />
    </div>
    <div class="content content--sravni" v-show="this.bool.previewPassed">
      <!-- <h1 @click="this.bool.previewPassed=false" class="content__title">Оформление</h1> -->
      <h1 class="content__title">Оформление</h1>
      <section class="content__section content__section--parameters section section--sravni">
        <div class="inputs inputs--sravni">
          <h3 class="inputs__title">Параметры договора страхования</h3>
          <ul class="inputs__list">
            <li class="inputs__item inputs__item--1-of-4 inputs__item--tablet-1-of-2">
              <div class="clp-input clp-input--sravni">
                <label class="clp-input__label clp-input__label--required" for="birth_date">
                  Дата рождения Страхователя
                </label>
                <input
                    v-model="this.dataContacts[0].birth_date" @input="this.errors = []"
                    class="clp-input__control" type="date" id="birth_date" placeholder="Дата рождения Страхователя"
                >
                <label v-if="this.errors[0] === 'birthDate'" class="clp-input__error" for="birth_date">
                  {{ this.errors[1] }}
                </label>
              </div>
            </li>
            <li class="inputs__item inputs__item--1-of-4 inputs__item--tablet-1-of-2">
              <div class="select select--sravni">
                <label class="select__label select__label--required" for="sex">
                  Пол страхователя
                </label>
                <select v-model="this.dataContacts[0].sex" class="select__control" name="sex" id="sex">
                  <option value="notSelected" style="display:none">Пол страхователя</option>
                  <option value="0">Мужской</option>
                  <option value="1">Женский</option>
                </select>
                <label v-if="this.errors[0] === 'sex'" class="select__error" for="sex">
                  {{ this.errors[1] }}
                </label>
              </div>
            </li>
            <li class="inputs__item inputs__item--1-of-4 inputs__item--tablet-1-of-2">
              <div class="select select--sravni">
                <label class="select__label select__label--required" for="ins_period">
                  Срок страхования
                </label>
                <select v-model="this.dataAgreement.ins_period" class="select__control" name="ins_period"
                        id="ins_period">
                  <option value="notSelected" style="display:none">Срок страхования</option>
                  <option value="2Y">2 года</option>
                  <option value="3Y">3 года</option>
                </select>
                <label v-if="this.errors[0] === 'ins_period'" class="select__error" for="ins_period">
                  {{ this.errors[1] }}
                </label>
              </div>
            </li>
            <li class="inputs__item inputs__item--1-of-4 inputs__item--tablet-hidden">
            </li>
            <li class="inputs__item inputs__item--1-of-4 inputs__item--tablet-1-of-2">
              <div class="clp-input clp-input--sravni">
                <label class="clp-input__label clp-input__label--required" for="ins_calc_amount">
                  Ежегодный взнос
                </label>
                <input v-model="this.dataAgreement.ins_calc_amount" class="clp-input__control" type="number"
                       id="ins_calc_amount" placeholder="Ежегодный взнос">
                <label v-if="this.errors[0] === 'ins_calc_amount'" class="clp-input__error" for="ins_calc_amount">
                  {{ this.errors[1] }}
                </label>
              </div>
            </li>
            <li class="inputs__item inputs__item--1-of-4 inputs__item--tablet-1-of-2">
              <div class="select select--sravni">
                <label class="select__label" for="payment_order">
                  Порядок оплаты
                </label>
                <select disabled v-model="this.dataAgreement.payment_order" class="select__control" name="payment_order"
                        id="payment_order">
                  <!-- <option value="notSelected" style="display:none">Порядок оплаты</option>                                -->
                  <option selected value="1">1 раз в год</option>
                </select>
                <label v-if="this.errors[0] === 'payment_order'" class="select__error" for="payment_order">
                  {{ this.errors[1] }}
                </label>
              </div>
            </li>
          </ul>
        </div>
      </section>
      <section class="content__section content__section--insurer section section--sravni">
        <h2 class="section__title section__title--tablet-mb-short">Страхователь</h2>
        <div class="inputs inputs--sravni">
          <h3 class="inputs__title">Персональные данные</h3>
          <ul class="inputs__list">
            <li class="inputs__item inputs__item--1-of-4 inputs__item--tablet-1-of-2">
              <div
                  class="clp-input clp-input--sravni"
                  :class="{'clp-input--errored': this.erroredFields.includes('last_name')}">
                <label class="clp-input__label clp-input__label--required" for="last_name">
                  Фамилия
                </label>
                <input v-model="this.dataContacts[0].last_name" class="clp-input__control" type="text" id="last_name"
                       placeholder="Фамилия">
                <label v-if="this.errors[0] === 'last_name'" class="clp-input__error" for="last_name">
                  {{ this.errors[1] }}
                </label>
              </div>
            </li>
            <li class="inputs__item inputs__item--1-of-4 inputs__item--tablet-1-of-2">
              <div class="clp-input clp-input--sravni"
                   :class="{'clp-input--errored': this.erroredFields.includes('first_name')}">
                <label class="clp-input__label clp-input__label--required" for="first_name">
                  Имя
                </label>
                <input v-model="this.dataContacts[0].first_name" class="clp-input__control" type="text" id="first_name"
                       placeholder="Имя">
                <label v-if="this.errors[0] === 'first_name'" class="clp-input__error" for="first_name">
                  {{ this.errors[1] }}
                </label>
              </div>
            </li>
            <li class="inputs__item inputs__item--1-of-4 inputs__item--tablet-1-of-2">
              <div class="clp-input clp-input--sravni"
                   :class="{'clp-input--errored': this.erroredFields.includes('middle_name')}">
                <label class="clp-input__label" for="middle_name">
                  Отчество
                </label>
                <input v-model="this.dataContacts[0].middle_name" class="clp-input__control" type="text"
                       id="middle_name" placeholder="Отчество">
                <label v-if="this.errors[0] === 'middle_name'" class="clp-input__error" for="middle_name">
                  {{ this.errors[1] }}
                </label>
              </div>
            </li>
            <li class="inputs__item inputs__item--1-of-4 inputs__item--tablet-hidden">
            </li>
            <li class="inputs__item inputs__item--1-of-4 inputs__item--tablet-1-of-2">
              <div class="clp-input clp-input--sravni">
                <label class="clp-input__label clp-input__label--required" for="birth_date">
                  Дата рождения
                </label>
                <input
                    v-model="this.dataContacts[0].birth_date"
                    @input="this.errors = []"
                    class="clp-input__control" type="date" id="birth_date" placeholder="Дата рождения">
                <!-- <label v-if="this.errors[0] === 'birthDate'" class="clp-input__error" for="birth_date">
                {{ this.errors[1] }}
                </label>    -->
              </div>
            </li>
            <li class="inputs__item inputs__item--1-of-4 inputs__item--tablet-1-of-2">
              <div class="select select--sravni">
                <label class="select__label" for="sex">
                  Пол
                </label>
                <select v-model="this.dataContacts[0].sex" class="select__control" name="sex" id="sex">
                  <option value="notSelected" style="display:none">Пол</option>
                  <option value="0">Мужской</option>
                  <option value="1">Женский</option>
                </select>
                <!-- <label v-if="this.errors[0] === 'sex'" class="select__error" for="sex">
                    {{ this.errors[1] }}
                </label> -->
              </div>
            </li>
            <li class="inputs__item inputs__item--1-of-4 inputs__item--tablet-1-of-2">

              <div class="clp-input clp-input--sravni">
                <label class="clp-input__label clp-input__label--required" for="middle_name">
                  Место рождения
                </label>
                <input v-model="this.dataContacts[0].birth_place" class="clp-input__control" type="text"
                       id="birth_place" placeholder="Место рождения">
                <label v-if="this.errors[0] === 'birth_place'" class="clp-input__error" for="birth_place">
                  {{ this.errors[1] }}
                </label>
              </div>
            </li>
            <li class="inputs__item inputs__item--1-of-4 inputs__item--tablet-1-of-2">
              <div class="select select--sravni">
                <label class="select__label select__label--required" for="citizenship">
                  Гражданство
                </label>
                <select disabled v-model="this.dataContacts[0].citizenship" class="select__control" name="citizenship"
                        id="citizenship">
                  <!-- <option value="notSelected" style="display:none">Гражданство</option> -->
                  <option selected value="rf">РФ</option>
                  <!-- <option value="other">Иное</option> -->
                </select>
                <label v-if="this.errors[0] === 'citizenship'" class="select__error" for="citizenship">
                  {{ this.errors[1] }}
                </label>
              </div>
            </li>
            <li class="inputs__item inputs__item--hidden inputs__item--tablet-1-of-2"></li>
            <li class="inputs__item inputs__item--1-of-4 inputs__item--tablet-1-of-2">
              <div class="clp-input clp-input--sravni">
                <label class="clp-input__label clp-input__label--required" for="phone_number">
                  Телефон
                </label>
                <input v-model="this.dataContacts[0].phone"
                       v-mask="{
                                mask: '+7 (FD#) ###-##-##',
                                tokens: {
                                    F: {
                                    pattern: /[3489]/,
                                    },
                                    D: {
                                    pattern: this.dataContacts[0].phone[4] == '8' ? /[0-8]/ : /\d/,
                                    },
                                    '#': { pattern: /\d/ },
                                },
                                }"
                       class="clp-input__control" type="text" id="phone_number" placeholder="Телефон">
                <label v-if="this.errors[0] === 'phone'" class="clp-input__error" for="phone_number">
                  {{ this.errors[1] }}
                </label>
              </div>
            </li>
            <li class="inputs__item inputs__item--1-of-4 inputs__item--tablet-1-of-2">
              <div class="clp-input clp-input--sravni">
                <label class="clp-input__label clp-input__label--required clp-input__label--red" for="email">
                  Электронная почта для получения пакета документов по договору страхования
                </label>
                <input v-model="this.dataContacts[0].email"
                       class="clp-input__control" type="email" id="email" placeholder="Электронная почта">
                <label v-if="this.errors[0] === 'email'" class="clp-input__error" for="email">
                  {{ this.errors[1] }}
                </label>
              </div>
            </li>
          </ul>
        </div>
        <div class="inputs inputs--sravni">
          <h3 class="inputs__title">Документы</h3>
          <ul class="inputs__list">
            <li class="inputs__item inputs__item--1-of-4 inputs__item--tablet-1-of-2">
              <div class="select select--sravni">
                <label class="select__label select__label--required" for="doc_type">
                  Тип документа
                </label>
                <select disabled v-model="this.dataDocuments[0].type" class="select__control" name="doc_type"
                        id="doc_type">
                  <!-- <option value="notSelected" style="display:none">Тип документа</option> -->
                  <option selected value="1">Паспорт РФ</option>
                </select>
                <label v-if="this.errors[0] === 'doc_type'" class="select__error" for="doc_type">
                  {{ this.errors[1] }}
                </label>
              </div>
            </li>
            <li class="inputs__item inputs__item--1-of-4 inputs__item--tablet-1-of-2">
              <div class="clp-input clp-input--sravni"
                   :class="{'clp-input--errored': this.erroredFields.includes('serial')}">
                <label class="clp-input__label clp-input__label--required" for="serial">
                  Серия
                </label>
                <input v-model="this.dataDocuments[0].serial"
                       v-mask="{mask: '####',tokens: {'#': { pattern: /\d/ },},}"
                       class="clp-input__control" type="text" id="serial" placeholder="Серия">
                <label v-if="this.errors[0] === 'serial'" class="clp-input__error" for="serial">
                  {{ this.errors[1] }}
                </label>
              </div>
            </li>
            <li class="inputs__item inputs__item--1-of-4 inputs__item--tablet-1-of-2">
              <div class="clp-input clp-input--sravni"
                   :class="{'clp-input--errored': this.erroredFields.includes('number')}">
                <label class="clp-input__label clp-input__label--required" for="number">
                  Hомер
                </label>
                <input v-model="this.dataDocuments[0].number"
                       v-mask="{mask: '### ###',tokens: {'#': { pattern: /\d/ },},}"
                       class="clp-input__control" type="text" id="number" placeholder="Hомер">
                <label v-if="this.errors[0] === 'number'" class="clp-input__error" for="number">
                  {{ this.errors[1] }}
                </label>
              </div>
            </li>
            <li class="inputs__item inputs__item--1-of-4 inputs__item--tablet-hidden">
            </li>
            <li class="inputs__item inputs__item--1-of-4 inputs__item--tablet-1-of-2">
              <div class="clp-input clp-input--sravni"
                   :class="{'clp-input--errored': this.erroredFields.includes('date')}">
                <label class="clp-input__label clp-input__label--required" for="doc_date">
                  Дата выдачи
                </label>
                <input
                    ref="doc_date"
                    v-model="this.dataDocuments[0].date"
                    @input="this.bool.requestArrived = true; this.errors = []"
                    class="clp-input__control" type="date" id="doc_date" placeholder="Дата выдачи"
                >
                <label v-if="this.errors[0] === 'doc_date'" class="clp-input__error" for="doc_date">
                  {{ this.errors[1] }}
                </label>
              </div>
            </li>
            <li class="inputs__item inputs__item--1-of-2 inputs__item--tablet-full">
              <div class="clp-input clp-input--sravni">
                <label class="clp-input__label clp-input__label--required" for="doc_auth">
                  Кем выдан
                </label>
                <input v-model="this.dataDocuments[0].auth" class="clp-input__control" type="text" id="doc_auth"
                       placeholder="Кем выдан">
                <label v-if="this.errors[0] === 'auth'" class="clp-input__error" for="doc_auth">
                  {{ this.errors[1] }}
                </label>
              </div>
            </li>
            <li class="inputs__item inputs__item--1-of-4 inputs__item--tablet-1-of-2">
              <div class="clp-input clp-input--sravni">
                <label class="clp-input__label clp-input__label--required" for="auth_code">
                  Код подразделения
                </label>
                <input v-model="this.dataDocuments[0].auth_code"
                       v-mask="{mask: '###-###',tokens: {'#': { pattern: /\d/ },},}"
                       class="clp-input__control" type="text" maxlength="7" id="auth_code"
                       placeholder="Код подразделения">
                <label v-if="this.errors[0] === 'auth_code'" class="clp-input__error" for="auth_code">
                  {{ this.errors[1] }}
                </label>
              </div>
            </li>
          </ul>
        </div>
        <div class="inputs inputs--sravni">
          <h3 class="inputs__title">Адрес места жительства (регистрации)</h3>
          <ul class="inputs__list">
            <li class="inputs__item inputs__item--1-of-4 inputs__item--tablet-1-of-2">
              <div class="clp-input clp-input--sravni">
                <label class="clp-input__label" for="index">
                  Индекс
                </label>
                <input v-model="this.dataAddresses[0].index"
                       v-mask="{mask: '######',tokens: {'#': { pattern: /\d/ },},}"
                       class="clp-input__control" type="text" id="index" placeholder="Индекс">
                <label v-if="this.errors[0] === 'index'" class="clp-input__error" for="index">
                  {{ this.errors[1] }}
                </label>
              </div>
            </li>
            <li class="inputs__item inputs__item--1-of-4 inputs__item--tablet-1-of-2">
              <auto-complete
                  v-model="this.dataAddresses[0].city"
                  :options="this.optionsCityReg"
                  @updateItem="($event) => {this.dataAddresses[0].city_code = $event.id}"
                  page="sravni" type='required' label='НП/ Город' placeholder='НП/ Город'
                  :show-err="this.errors[0] === 'cityReg'" :err-text="this.errors[1]"
              />
            </li>
            <li class="inputs__item inputs__item--1-of-4 inputs__item--tablet-1-of-2">
              <auto-complete
                  v-model="this.dataAddresses[0].street"
                  :options="this.optionsStreetReg"
                  @updateItem="($event) => {this.dataAddresses[0].street_code = $event.id}"
                  page="sravni" type='required' label='Улица' placeholder='Улица'
                  :show-err="this.errors[0] === 'streetReg'" :err-text="this.errors[1]"
              />
            </li>
            <li class="inputs__item inputs__item--1-of-4 inputs__item--tablet-hidden"></li>
            <li class="inputs__item inputs__item--1-of-6 inputs__item--tablet-1-of-2">
              <div class="clp-input clp-input--sravni">
                <label class="clp-input__label clp-input__label--required" for="house">
                  Дом
                </label>
                <input v-model="this.dataAddresses[0].house" class="clp-input__control" type="tel" maxlength="4"
                       id="house" placeholder="Дом">
                <label v-if="this.errors[0] === 'houseReg'" class="clp-input__error" for="house">
                  {{ this.errors[1] }}
                </label>
              </div>
            </li>
            <li class="inputs__item inputs__item--1-of-6 inputs__item--tablet-1-of-3">
              <div class="clp-input clp-input--sravni">
                <label class="clp-input__label" for="housing">
                  Корпус
                </label>
                <input v-model="this.dataAddresses[0].housing" class="clp-input__control" type="text" id="housing"
                       placeholder="Корпус">
                <label v-if="this.errors[0] === 'housingReg'" class="clp-input__error" for="housing">
                  {{ this.errors[1] }}
                </label>
              </div>
            </li>
            <li class="inputs__item inputs__item--1-of-6 inputs__item--tablet-1-of-3">
              <div class="clp-input clp-input--sravni">
                <label class="clp-input__label" for="building">
                  Строение
                </label>
                <input v-model="this.dataAddresses[0].building" class="clp-input__control" type="text" id="building"
                       placeholder="Строение">
                <label v-if="this.errors[0] === 'buildingReg'" class="clp-input__error" for="building">
                  {{ this.errors[1] }}
                </label>
              </div>
            </li>
            <li class="inputs__item inputs__item--1-of-6 inputs__item--tablet-1-of-3">
              <div class="clp-input clp-input--sravni">
                <label class="clp-input__label" for="apartment">
                  Квартира
                </label>
                <input v-model="this.dataAddresses[0].apartment" class="clp-input__control" type="tel" maxlength="4"
                       id="apartment" placeholder="Квартира">
                <label v-if="this.errors[0] === 'apartmentReg'" class="clp-input__error" for="apartment">
                  {{ this.errors[1] }}
                </label>
              </div>
            </li>
          </ul>
          <div class="checkbox checkbox--sravni">
            <input @click="this.toggleFactAddress()"
                   v-model="this.bool.factAddressIsRegAddress"
                   class="checkbox__input" type="checkbox" name="address" value="address" id="address">
            <label class="checkbox__label" for="address">
              <span class="checkbox__label--icon">
                <img class="icon" src="@/create/assets/icons/check.svg">
              </span>
              <span class="checkbox__label--text">
                Адрес фактического места жительства совпадает с адресом регистрации
              </span>
            </label>
          </div>
        </div>
        <div v-show="!this.bool.factAddressIsRegAddress" class="inputs inputs--sravni">
          <h3 class="inputs__title">Адрес места жительства (фактический)</h3>
          <ul class="inputs__list">
            <li class="inputs__item inputs__item--1-of-4 inputs__item--tablet-1-of-2">
              <div class="clp-input clp-input--sravni">
                <label class="clp-input__label" for="index">
                  Индекс
                </label>
                <input v-model="this.dataAddresses[1].index"
                       v-mask="{mask: '######',tokens: {'#': { pattern: /\d/ },},}"
                       class="clp-input__control" type="text" id="index" placeholder="Индекс">
                <label v-if="this.errors[0] === 'indexFact'" class="clp-input__error" for="index">
                  {{ this.errors[1] }}
                </label>
              </div>
            </li>
            <li class="inputs__item inputs__item--1-of-4 inputs__item--tablet-1-of-2">
              <auto-complete
                  v-model="this.dataAddresses[1].city"
                  :options="this.optionsCityFact"
                  @updateItem="($event) => {this.dataAddresses[1].city_code = $event.id}"
                  page="sravni" type='required' label='НП/ Город' placeholder='НП/ Город'
                  :show-err="this.errors[0] === 'cityFact'" :err-text="this.errors[1]"
              />
            </li>
            <li class="inputs__item inputs__item--1-of-4 inputs__item--tablet-1-of-2">
              <auto-complete
                  v-model="this.dataAddresses[1].street"
                  :options="this.optionsStreetFact"
                  @updateItem="($event) => {this.dataAddresses[1].street_code = $event.id}"
                  page="sravni" type='required' label='Улица' placeholder='Улица'
                  :show-err="this.errors[0] === 'streetFact'" :err-text="this.errors[1]"
              />
            </li>
            <li class="inputs__item inputs__item--1-of-4 inputs__item--tablet-hidden">
            </li>
            <li class="inputs__item inputs__item--1-of-6 inputs__item--tablet-1-of-2">
              <div class="clp-input clp-input--sravni">
                <label class="clp-input__label clp-input__label--required" for="house">
                  Дом
                </label>
                <input v-model="this.dataAddresses[1].house" class="clp-input__control" type="tel" maxlength="4"
                       id="house" placeholder="Дом">
                <label v-if="this.errors[0] === 'houseFact'" class="clp-input__error" for="house">
                  {{ this.errors[1] }}
                </label>
              </div>
            </li>
            <li class="inputs__item inputs__item--1-of-6 inputs__item--tablet-1-of-3">
              <div class="clp-input clp-input--sravni">
                <label class="clp-input__label" for="housing">
                  Корпус
                </label>
                <input v-model="this.dataAddresses[1].housing" class="clp-input__control" type="text" id="housing"
                       placeholder="Корпус">
                <label v-if="this.errors[0] === 'housingFact'" class="clp-input__error" for="housing">
                  {{ this.errors[1] }}
                </label>
              </div>
            </li>
            <li class="inputs__item inputs__item--1-of-6 inputs__item--tablet-1-of-3">
              <div class="clp-input clp-input--sravni">
                <label class="clp-input__label" for="building">
                  Строение
                </label>
                <input v-model="this.dataAddresses[1].building" class="clp-input__control" type="text" id="building"
                       placeholder="Строение">
                <label v-if="this.errors[0] === 'buildingFact'" class="clp-input__error" for="building">
                  {{ this.errors[1] }}
                </label>
              </div>
            </li>
            <li class="inputs__item inputs__item--1-of-6 inputs__item--tablet-1-of-3">
              <div class="clp-input clp-input--sravni">
                <label class="clp-input__label" for="apartment">
                  Квартира
                </label>
                <input v-model="this.dataAddresses[1].apartment" class="clp-input__control" type="tel" maxlength="4"
                       id="apartment" placeholder="Квартира">
                <label v-if="this.errors[0] === 'apartmentFact'" class="clp-input__error" for="apartment">
                  {{ this.errors[1] }}
                </label>
              </div>
            </li>
          </ul>
        </div>
      </section>
      <section class="content__section content__section--insured section section--sravni">
        <h2 class="section__title">Застрахованный</h2>
        <div class="checkbox checkbox--sravni">
          <input checked disabled class="checkbox__input" type="checkbox" name="insured" value="insured" id="insured">
          <label class="checkbox__label" for="insured">
            <span class="checkbox__label--icon">
              <img class="icon" src="@/create/assets/icons/check.svg">
            </span>
            <span class="checkbox__label--text">
              Застрахованный является страхователем
            </span>
          </label>
        </div>
      </section>
      <section class="content__section content__section--beneficiaries section section--sravni">
        <h2 class="section__title section__title--mb-short">
          Выгодоприобретатели
          <nobr>(на случай смерти застрахованного лица)</nobr>
        </h2>
        <div class="checkbox checkbox--sravni checkbox--mb-long">
          <input @click="this.toggleBeneficiaries()"
                 v-model="this.bool.heirsAreBeneficiaries"
                 class="checkbox__input" type="checkbox" name="beneficiaries" value="beneficiaries" id="beneficiaries">
          <label class="checkbox__label" for="beneficiaries">
            <span class="checkbox__label--icon">
              <img class="icon" src="@/create/assets/icons/check.svg">
            </span>
            <span class="checkbox__label--text">
              Наследники Застрахованного являются Выгодоприобретателями
            </span>
          </label>
        </div>
        <!-- Выгодоприобретатель 1-5 -->
        <div
            v-for="(item, index) in this.dataAgreement.beneficiaries"
            :key="item.contact"
            class="inputs inputs--sravni inputs--sravni-beneficiaries"
        >
          <h3 class="inputs__heading">{{ 'Выгодоприобретатель ' + (index + 1) }}</h3>
          <h3 class="inputs__title">Персональные данные</h3>
          <ul class="inputs__list">
            <li class="inputs__item inputs__item--1-of-4 inputs__item--tablet-1-of-2">
              <div class="clp-input clp-input--sravni">
                <label class="clp-input__label clp-input__label--required" for="last_name">
                  Фамилия
                </label>
                <input v-model="this.dataContacts[index + 1].last_name" class="clp-input__control" type="text"
                       id="last_name" placeholder="Фамилия">
                <label v-if="this.errors[0] === 'last_name'+index" class="clp-input__error" for="last_name">
                  {{ this.errors[1] }}
                </label>
              </div>
            </li>
            <li class="inputs__item inputs__item--1-of-4 inputs__item--tablet-1-of-2">
              <div class="clp-input clp-input--sravni">
                <label class="clp-input__label clp-input__label--required" for="first_name">
                  Имя
                </label>
                <input v-model="this.dataContacts[index + 1].first_name" class="clp-input__control" type="text"
                       id="first_name" placeholder="Имя">
                <label v-if="this.errors[0] === 'first_name'+index" class="clp-input__error" for="first_name">
                  {{ this.errors[1] }}
                </label>
              </div>
            </li>
            <li class="inputs__item inputs__item--1-of-4 inputs__item--tablet-1-of-2">
              <div class="clp-input clp-input--sravni">
                <label class="clp-input__label" for="middle_name">
                  Отчество
                </label>
                <input v-model="this.dataContacts[index + 1].middle_name" class="clp-input__control" type="text"
                       id="middle_name" placeholder="Отчество">
                <label v-if="this.errors[0] === 'middle_name'+index" class="clp-input__error" for="middle_name">
                  {{ this.errors[1] }}
                </label>
              </div>
            </li>
            <li class="inputs__item inputs__item--1-of-4 inputs__item--tablet-hidden"></li>
            <li class="inputs__item inputs__item--1-of-4 inputs__item--tablet-1-of-2">
              <div class="clp-input clp-input--sravni">
                <label class="clp-input__label clp-input__label--required" for="birth_date">
                  Дата рождения
                </label>
                <input v-model="this.dataContacts[index + 1].birth_date" class="clp-input__control" type="date"
                       id="birth_date" placeholder="Дата рождения">
                <label v-if="this.errors[0] === 'birthDate'+index" class="clp-input__error" for="birth_date">
                  {{ this.errors[1] }}
                </label>
              </div>
            </li>
            <li class="inputs__item inputs__item--1-of-4 inputs__item--tablet-1-of-2">
              <div class="clp-input clp-input--sravni">
                <label class="clp-input__label" for="relationship">
                  Родственные отношения
                </label>
                <input v-model="item.relationship" class="clp-input__control" type="text" id="relationship"
                       placeholder="Родственные отношения">
                <label v-if="this.errors[0] === 'relationship'+index" class="clp-input__error" for="relationship">
                  {{ this.errors[1] }}
                </label>
              </div>
            </li>
            <li class="inputs__item inputs__item--1-of-4 inputs__item--tablet-1-of-2">
              <div class="clp-input clp-input--sravni">
                <label class="clp-input__label clp-input__label--required" for="address">
                  Адрес регистрации
                </label>
                <input v-model="this.dataAddresses[index + 2].addresses" class="clp-input__control" type="text"
                       id="address" placeholder="Адрес регистрации">
                <label v-if="this.errors[0] === 'address'+index" class="clp-input__error" for="address">
                  {{ this.errors[1] }}
                </label>
              </div>
            </li>
            <li class="inputs__item inputs__item--1-of-4 inputs__item--tablet-1-of-2">
              <div class="clp-input clp-input--sravni">
                <label class="clp-input__label clp-input__label--required" for="part">
                  Доля от страховой суммы, %
                </label>
                <input v-model="item.part"
                       v-mask="{mask: '###',tokens: {'#': { pattern: /\d/ }, },}"
                       class="clp-input__control" id="part" type="text" placeholder="Доля от страховой суммы, %">
                <label v-if="this.errors[0] === 'part'+index || this.errors[0] === 'part'" class="clp-input__error"
                       for="part">
                  {{ this.errors[1] }}
                </label>
              </div>
            </li>
          </ul>
        </div>
        <div v-show="this.dataAgreement.beneficiaries.length > 0" class="section__buttons-beneficiaries">
          <button @click="this.addBeneficiary()" v-show="this.dataAgreement.beneficiaries.length < 5"
                  class="button button--sravni-iconed">
            +
          </button>
          <button disabled v-show="this.dataAgreement.beneficiaries.length === 5" class="button button--sravni-iconed">
            +
          </button>
          <button
              @click="this.removeBeneficiary()"
              class="button button--sravni-iconed"
              style="box-sizing: border-box; padding-bottom: 4px;">
            -
          </button>
        </div>
      </section>
      <section class="content__section content__section--confirmation section section--sravni">
        <h2 class="section__title section__title--mb-short">
          Подтверждение данных
        </h2>
        <div class="info">
          <img class="info__img icon" src="@/create/assets/icons/shield-check.svg">
          <div class="info__descr">
            Ваши данные не&nbsp;попадут третьим лицам. Мы&nbsp;соблюдаем закон о&nbsp;защите персональных данных
          </div>
        </div>
        <div class="section__checkboxes checkboxes">
          <ul class="checkboxes__list">
            <li class="checkboxes__item">
              <div class="checkbox checkbox--sravni">
                <input v-model="this.arr.markedCheckboxes" class="checkbox__input" type="checkbox" name="check[]"
                       value="check_residency" id="check_residency">
                <label class="checkbox__label" for="check_residency">
                  <span class="checkbox__label--icon">
                    <img class="icon" src="@/create/assets/icons/check.svg">
                  </span>
                  <span class="checkbox__label--text">
                    <b>Страхователь подтверждает, что не&nbsp;имеет гражданства США, разрешения на&nbsp;постоянное пребывание в&nbsp;США и&nbsp;не&nbsp;является налоговым резидентом США.</b>
                  </span>
                </label>
              </div>
            </li>
            <li class="checkboxes__item">
              <div class="checkbox checkbox--sravni">
                <input v-model="this.arr.markedCheckboxes" class="checkbox__input" type="checkbox" name="check[]"
                       value="check_office" id="check_office">
                <label class="checkbox__label" for="check_office">
                  <span class="checkbox__label--icon">
                    <img class="icon" src="@/create/assets/icons/check.svg">
                  </span>
                  <span class="checkbox__label--text">
                    <b>Страхователь подтверждает, что не&nbsp;является:</b>
                    <br><br>&mdash;&nbsp;иностранным публичным должностным лицом, должностным лицом публичных международных организаций;
                    <br><br>&mdash;&nbsp;лицом, замещающим (занимающим) государственные должности&nbsp;РФ, должности членов Совета директоров ЦБ&nbsp;РФ, должности федеральной государственной службы, назначение на&nbsp;которые и&nbsp;освобождение от&nbsp;которых осуществляется Президентом РФ&nbsp;или Правительством&nbsp;РФ, должности в&nbsp;ЦБ&nbsp;РФ, государственных корпорациях и&nbsp;иных организациях, созданных&nbsp;РФ на&nbsp;основании федеральных законов, включенные в&nbsp;перечни должностей, определяемые Президентом РФ;
                    <br><br>&mdash;&nbsp;супругой(-ом), близким родственником лиц, указанных в&nbsp;настоящем подпункте.
                    <br><br>&nbspОплачивать договор страхования необходимо банковской картой, оформленной на&nbsp;имя Страхователя. При оплате договора третьим лицом может быть удержан налог с&nbsp;внесенной суммы.
                  </span>
                </label>
              </div>
            </li>
            <li class="checkboxes__item">
              <div class="checkbox checkbox--sravni">
                <input v-model="this.arr.markedCheckboxes" class="checkbox__input" type="checkbox" name="check[]"
                       value="check_tax" id="check_tax">
                <label class="checkbox__label" for="check_tax">
                  <span class="checkbox__label--icon">
                    <img class="icon" src="@/create/assets/icons/check.svg">
                  </span>
                  <span class="checkbox__label--text">
                    <b>Страхователь подтверждает, что ему доведена следующая информация:</b>
                    <br><br>&mdash;&nbsp;в соответствии со ст. 213 НК РФ страховая выплата по окончанию договора страхования не облагается налогом на доходы физических лиц в полном объеме в случаях, если оплата договора страхования производилась лично Страхователем за счет его собственных средств. В иных случаях может быть удержан налог с суммы оплаченных взносов.
                  </span>
                </label>
              </div>
            </li>
          </ul>
        </div>
        <div class="section__checkboxes checkboxes">
          <ul class="checkboxes__list">
            <li class="checkboxes__item">
              <div class="checkbox checkbox--sravni">
                <input v-model="this.arr.markedCheckboxes" class="checkbox__input" type="checkbox" name="check[]"
                       value="personal_data" id="checkbox1">
                <label class="checkbox__label" for="checkbox1">
                  <span class="checkbox__label--icon">
                    <img class="icon" src="@/create/assets/icons/check.svg">
                  </span>
                  <span class="checkbox__label--text">Согласен с
                    <a class="clp-link clp-link--sravni" target="_blank"
                       href="https://makclife.ru/o-kompanii/obrabotka-personalnykh-dannykh.php">Политикой обработки данных</a>
                  </span>
                </label>
              </div>
            </li>
            <li class="checkboxes__item">
              <div class="checkbox checkbox--sravni">
                <!--   TODO разделить arr.markedCheckboxes на отдельные переменные, чтобы провекрка условий было гибче   -->
                <input v-model="checkbox_user_agreement"  class="checkbox__input" type="checkbox" name="check[]"
                       value="user_agreement" id="checkbox4">
                <label class="checkbox__label" for="checkbox4">
                  <span class="checkbox__label--icon">
                    <img class="icon" src="@/create/assets/icons/check.svg" alt="">
                  </span>
                  <span class="checkbox__label--text">Ознакомился и согласился с
                    <a class="clp-link clp-link--sravni"  target="_blank"
                       href="https://makclife.ru/upload/medialibrary/ff8/2mo5whoofnvsxzgavmmx04ri1ua0jbdj/%D0%9F%D0%BE%D0%BB%D1%8C%D0%B7%D0%BE%D0%B2%D0%B0%D1%82%D0%B5%D0%BB%D1%8C%D1%81%D0%BA%D0%BE%D0%B5%20%D1%81%D0%BE%D0%B3%D0%BB%D0%B0%D1%88%D0%B5%D0%BD%D0%B8%D0%B5.pdf">Пользовательским соглашением</a>
                  </span>
                </label>
              </div>
            </li>
            <li v-show="this.bool.newKidArrived && checkbox_user_agreement" class="checkboxes__item">
              <div class="checkbox checkbox--sravni">
                <input v-model="this.arr.markedCheckboxes" class="checkbox__input" type="checkbox" name="check[]"
                       value="kid_and_ins_terms" id="checkbox2">
                <label class="checkbox__label" for="checkbox2">
                  <span class="checkbox__label--icon">
                    <img class="icon" src="@/create/assets/icons/check.svg">
                  </span>
                  <span class="checkbox__label--text">Ознакомился с
                    <a class="clp-link clp-link--sravni" target="_blank" :href="this.str.kidLink">Ключевым информационным документом</a>
                  </span>
                </label>
              </div>
            </li>
            <li v-show="!this.bool.newKidArrived || !checkbox_user_agreement" class="checkboxes__item">
              <div class="checkbox checkbox--sravni">
                <input disabled class="checkbox__input" type="checkbox" name="check[]" value="disabled" id="disabled">
                <label class="checkbox__label" for="disabled">
                  <span class="checkbox__label--icon">
                    <img class="icon" src="@/create/assets/icons/check.svg">
                  </span>
                  <span class="checkbox__label--text">Ознакомился с
                    <a class="clp-link clp-link--sravni clp-link--disabled">Ключевым информационным документом</a>
                  </span>
                </label>
              </div>
            </li>
            <li v-show="this.bool.newKidArrived && this.str.rulesLink !== '#'" class="checkboxes__item">
              <div class="checkbox checkbox--sravni">
                <input v-model="this.arr.markedCheckboxes" class="checkbox__input" type="checkbox" name="check[]"
                       value="policy_terms_and_ins_rules" id="checkbox3">
                <label class="checkbox__label" for="checkbox3">
                  <span class="checkbox__label--icon">
                    <img class="icon" src="@/create/assets/icons/check.svg">
                  </span>
                  <span class="checkbox__label--text">Ознакомился и согласился с
                    <a v-if="this.bool.newKidArrived" class="clp-link clp-link--sravni" target="_blank"
                       :href="this.str.policyLink">Условиями полиса</a> и
                    <a v-if="this.str.rulesLink !== '#'" class="clp-link clp-link--sravni"
                       target="_blank" :href="this.str.rulesLink">Правилами страхования</a>
                  </span>
                </label>
              </div>
            </li>
            <li v-show="!this.bool.newKidArrived || this.str.rulesLink === '#'" class="checkboxes__item">
              <div class="checkbox checkbox--sravni">
                <input disabled class="checkbox__input" type="checkbox" name="check[]" value="disabled2" id="disabled2">
                <label class="checkbox__label" for="disabled2">
                  <span class="checkbox__label--icon">
                    <img class="icon" src="@/create/assets/icons/check.svg" alt="">
                  </span>
                  <span class="checkbox__label--text">Ознакомился и согласился с
                    <a class="clp-link clp-link--sravni clp-link--disabled">Условиями полиса</a> и
                    <a class="clp-link clp-link--sravni clp-link--disabled">Правилами страхования</a>
                  </span>
                </label>
              </div>
            </li>
          </ul>
        </div>
        <div class="section__subtitle">
          Для завершения оформления договора подтвердите свои данные через безопасное соединение в&nbsp;Единой системе
          идентификации и&nbsp;аутентификации сервиса
          <img style="max-height: 1.1em; transform: translate(3px, 5.5px);" src="@/create/assets/icons/gosuslugi.svg"
               alt="ГосУслуги">
        </div>
        <div class="section__subtitle">
          После подтверждения данных и завершения оплаты полис и&nbsp;комплект страховых документов будут направлены на&nbsp;указанный
          Вами адрес электронной почты.
        </div>
        <div class="section__buttons-confirmation">
          <button
              v-show="this.arr.markedCheckboxes.length === 6 && checkbox_user_agreement"
              :disabled="this.arr.markedCheckboxes.length < 6 || !checkbox_user_agreement"
              @click="openGosuslugi()"
              class="section__button button button--sravni button--largetext button--col-mobile"
          >
            Подтвердить данные через
            <img style="max-height: 1.1em; transform: translate(3.5px, 2px); margin: 0 10px 0 2px;"
                 src="@/create/assets/icons/gosuslugi.svg" alt="ГосУслуги">
            и перейти к оплате
          </button>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import ClpDialog from '@/create/components/ClpDialog.vue';
import ClpConfirmation from '@/create/components/ClpConfirmation.vue';
import ClpError from '@/create/components/ClpError.vue';
import ClpAutocomplete from '@/create/components/ClpAutocomplete.vue';
import AutoComplete from '@/create/components/AutoComplete.vue';
import ClpPreview from '@/create/components/ClpPreview.vue';
import axios from 'axios';
import {localDevelopment, subdomain, testDevelopment, baseURL} from "@/create/composables/const";

export default {
  name: "Sravni",
  components: {
    ClpDialog, ClpConfirmation, ClpError, ClpAutocomplete, AutoComplete, ClpPreview
  },
  data() {
    return {
      bool: {
        showDialog: false,
        showErrorDialog: false,
        showInlineAlert: false,
        newKidArrived: false,
        requestAvailable: false,
        requestArrived: false,
        previewPassed: false,
        factAddressIsRegAddress: true,
        heirsAreBeneficiaries: true,
        codeCheckAvbl: false,
      },
      str: {
        cyrillicAndNums: /^[\u0400-\u04FF\s'\.,-\/#!$%\^&\*;:{}=\-_`~()\d]+$/,
        cyrillic: /^[\u0400-\u04FF\s'\.,-\/#!$%\^&\*;:{}=\-_`~()]+$/,
        latin: /^[A-z\u00C0-\u00ff\s'\.,-\/#!$%\^&\*;:{}=\-_`~()]+$/,
        kidLink: '#',
        policyLink: '#',
        rulesLink: '#',
        sessionToken: '',
        contractAmount: '0000',
        errorDialogType: 'server_fail',
        step: 'loader',
        loaderType: 'simple',
        contractId: '',
        msgAlert: '',
        numbers: '',
      },
      arr: {
        markedCheckboxes: [],
      },
      dataAgreement: {
        // "beneficiaries": [],
        // "program": "gp",
        // "ins_calc_amount": 100000,
        // "ins_calc_type": "0",
        // "ins_period": "2Y",
        // "payment_order": "1",
        // "currency": "rur",
        // "insurer": 0,
        // "insured": 0,
        // "status": 10,
        // "bank_policy_premium": 0,
        // "ins_rules": true,
        // "variant_id": "18",
        // "variant_type": "4",
        // "menu_id": "12",
        // "named_params": {},
        // "creat_previe_police": "Y"
        beneficiaries: [],
        program: "gp",
        ins_calc_amount: '',
        ins_calc_type: '0',
        ins_period: "notSelected",
        payment_order: '1',
        currency: "rur",
        insurer: 0,
        insured: 0,
        status: 10,
        bank_policy_premium: 0,
        ins_rules: true,
        variant_id: "18",
        variant_type: '4',
        menu_id: '12',
        named_params: {},
        creat_previe_police: 'Y'
      },
      dataDocuments: [
        // {
        //   "type": "1",
        //   "serial": "1111",
        //   "number": "222 222",
        //   "date": "2014-10-20",
        //   "auth": "ыаымимсисимсисмимсисмиммисимсисм",
        //   "auth_code": "123-123"
        // },
        {
          type: '1',
          serial: "",
          number: "",
          date: "",
          auth: "",
          auth_code: ""
        }
      ],
      dataAddresses: [
        // {
        //   "index": "109458",
        //   "city": "",
        //   "city_code": "2400900002200",
        //   "street": "Ветеранов ул.",
        //   "street_code": "",
        //   "house": "4",
        //   "housing": "2",
        //   "building": "1",
        //   "apartment": "111"
        // },
        {
          index: "",
          city: "",
          city_code: "",
          street: "",
          street_code: "",
          house: "",
          housing: "",
          building: "",
          apartment: ""
        },
        {
          index: "",
          city: "",
          city_code: "",
          street: "",
          street_code: "",
          house: "",
          housing: "",
          building: "",
          apartment: ""
        },
      ],
      dataContacts: [
        // {
        //   "first_name": "фыв",
        //   "middle_name": "ячс",
        //   "last_name": "йцу",
        //   "birth_date": "2000-10-20",
        //   "phone": "+7 (888) 888-88-88",
        //   "email": "asd@asd.ru",
        //   "birth_place": "Минск",
        //   "citizenship": "rf",
        //   "sex": "0",
        //   "documents": ["0"],
        //   "addresses": ["0", "0"]
        // },
        {
          first_name: "",
          middle_name: "",
          last_name: "",
          birth_date: "",
          phone: "",
          email: "",
          birth_place: "",
          citizenship: "rf",
          sex: "notSelected",
          documents: ['0'],
          addresses: ['0', '0'],
        },
      ],
      errors: [],
      erroredFields: [],
      optionsCityReg: [],
      optionsStreetReg: [],
      optionsCityFact: [],
      optionsStreetFact: [],
      checkbox_user_agreement: false,
    };
  },
  methods: {
    // валидация
    frontValidate() {
      if (this.errors[0] === 'doc_date'
          && this.errors[1] !== 'укажите дату выдачи'
          && this.errors[1] !== 'укажите корректную дату выдачи (с 14 лет)'
      ) {
        return
      }
      this.errors = [];
      const authCode = /[0-9][0-9][0-9]\-[0-9][0-9][0-9]/;
      // const phone = /^\w+\.*\w*@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/;
      const email = /^[a-zA-Z0-9._-]+@[a-zA-Z_-]+?\.[a-zA-Z]{2,3}$/;

      // Параметры договора страхования
      if (true) {
        if (false) {
          return false
        } else if (!this.dataContacts[0].birth_date) {
          this.errors.push('birthDate');
          this.errors.push('укажите корректную дату рождения страхователя');
          return false
        } else if (this.getAge(this.dataContacts[0].birth_date) < 18 || this.getAge(this.dataContacts[0].birth_date) > 70) {
          this.errors.push('birthDate');
          this.errors.push('допустимый возраст - от 18 до 70 лет');
          return false
        } else if (this.dataContacts[0].sex === 'notSelected') {
          this.errors.push('sex');
          this.errors.push('укажите пол');
          return false
        } else if (this.dataAgreement.ins_period === 'notSelected') {
          this.errors.push('ins_period');
          this.errors.push('укажите срок страхования');
          return false
        } else if (this.dataAgreement.ins_calc_amount < 1) {
          this.errors.push('ins_calc_amount');
          this.errors.push('укажите ежегодный взнос');
          return false
        } else if (this.dataAgreement.ins_calc_amount < 100000) {
          this.errors.push('ins_calc_amount');
          this.errors.push('минимальная сумма - 100 000 руб.');
          return false
        } else if (this.dataAgreement.ins_calc_amount > 1000000) {
          this.errors.push('ins_calc_amount');
          this.errors.push('максимальная сумма - 1 000 000 руб.');
          return false
        }
      }
      // Персональные данные
      if (true) {
        if (false) {
          return false
        } else if (!this.dataContacts[0].last_name) {
          this.errors.push('last_name');
          this.errors.push('укажите фамилию');
          return false
        } else if (!this.str.cyrillic.test(this.dataContacts[0].last_name)) {
          this.errors.push('last_name');
          this.errors.push('допустимы только символы кириллицы');
          return false
        } else if (this.dataContacts[0].last_name.length < 3) {
          this.errors.push('last_name');
          this.errors.push('укажите фамилию полностью');
          return false
        } else if (!this.dataContacts[0].first_name) {
          this.errors.push('first_name');
          this.errors.push('укажите имя');
          return false
        } else if (!this.str.cyrillic.test(this.dataContacts[0].first_name)) {
          this.errors.push('first_name');
          this.errors.push('допустимы только символы кириллицы');
          return false
        } else if (this.dataContacts[0].first_name.length < 3) {
          this.errors.push('first_name');
          this.errors.push('укажите имя полностью');
          return false
        } else if (this.dataContacts[0].first_name && this.dataContacts[0].first_name === this.dataContacts[0].last_name) {
          this.errors.push('first_name');
          this.errors.push('одинаковые имя и фамилия недопустимы');
          return false
        } else if (this.dataContacts[0].middle_name && this.dataContacts[0].middle_name === this.dataContacts[0].last_name) {
          this.errors.push('middle_name');
          this.errors.push('одинаковые отчество и фамилия недопустимы');
          return false
        } else if (this.dataContacts[0].middle_name && this.dataContacts[0].middle_name === this.dataContacts[0].first_name) {
          this.errors.push('middle_name');
          this.errors.push('одинаковые имя и отчество недопустимы');
          return false
        } else if (this.dataContacts[0].middle_name && !this.str.cyrillic.test(this.dataContacts[0].middle_name)) {
          this.errors.push('middle_name');
          this.errors.push('допустимы только символы кириллицы');
          return false
        } else if (this.dataContacts[0].middle_name && this.dataContacts[0].middle_name.length < 3) {
          this.errors.push('middle_name');
          this.errors.push('укажите отчество полностью');
          return false
        } else if (!this.dataContacts[0].birth_place) {
          this.errors.push('birth_place');
          this.errors.push('укажите место рождения');
          return false
        } else if (!this.str.cyrillicAndNums.test(this.dataContacts[0].birth_place)) {
          this.errors.push('birth_place');
          this.errors.push('допустимы только символы кириллицы');
          return false
        } else if (!this.dataContacts[0].phone) {
          this.errors.push('phone');
          this.errors.push('укажите номер телефона');
          return false
        } else if (this.dataContacts[0].phone.length < 18) {
          this.errors.push('phone');
          this.errors.push('укажите номер телефона полностью');
          return false
        } else if (!this.dataContacts[0].email) {
          this.errors.push('email');
          this.errors.push('укажите адрес электронной почты');
          return false
        } else if (!email.test(this.dataContacts[0].email)) {
          this.errors.push('email');
          this.errors.push('укажите корректный адрес электронной почты');
          return false
        }
      }
      // Документы
      if (true) {
        if (false) {
          return false
        } else if (!this.dataDocuments[0].serial) {
          this.errors.push('serial');
          this.errors.push('укажите серию паспорта');
          return false
        } else if (this.dataDocuments[0].serial.length !== 4) {
          this.errors.push('serial');
          this.errors.push('укажите серию паспорта (4 цифры)');
          return false
        } else if (!this.dataDocuments[0].number) {
          this.errors.push('number');
          this.errors.push('укажите номер паспорта');
          return false
        } else if (this.dataDocuments[0].number.length < 7) {
          this.errors.push('number');
          this.errors.push('укажите номер паспорта (6 цифр)');
          return false
        } else if (!this.dataDocuments[0].date) {
          this.errors.push('doc_date');
          this.errors.push('укажите дату выдачи');
          return false
        } else if (!this.checkDocDate()) {
          this.errors.push('doc_date');
          this.errors.push('укажите корректную дату выдачи (с 14 лет)');
          return false
        } else if (!this.dataDocuments[0].auth) {
          this.errors.push('auth');
          this.errors.push('укажите подразделение');
          return false
        } else if (!this.str.cyrillicAndNums.test(this.dataDocuments[0].auth)) {
          this.errors.push('auth');
          this.errors.push('допустимы только символы кириллицы');
          return false
        } else if (!this.dataDocuments[0].auth_code) {
          this.errors.push('auth_code');
          this.errors.push('укажите код подразделения');
          return false
        } else if (!authCode.test(this.dataDocuments[0].auth_code)) {
          this.errors.push('auth_code');
          this.errors.push('укажите код подразделения в формате 123-456');
          return false
        }
      }
      // Адрес регистрации / фактический
      if (true) {
        if (false) {
          return false
        } else if (!this.dataAddresses[0].city || !this.dataAddresses[0].city_code) {
          this.errors.push('cityReg');
          this.errors.push('укажите город');
          return false
        } else if (!this.str.cyrillicAndNums.test(this.dataAddresses[0].city)) {
          this.errors.push('cityReg');
          this.errors.push('допустимы только символы кириллицы');
          return false
        } else if (!this.dataAddresses[0].street) {
          this.errors.push('streetReg');
          this.errors.push('укажите улицу');
          return false
        } else if (!this.str.cyrillicAndNums.test(this.dataAddresses[0].street)) {
          this.errors.push('streetReg');
          this.errors.push('допустимы только символы кириллицы');
          return false
        } else if (!this.dataAddresses[0].house) {
          this.errors.push('houseReg');
          this.errors.push('укажите дом');
          return false
        } else if (!this.bool.factAddressIsRegAddress) {
          if (false) {
            return false
          } else if (!this.dataAddresses[1].city || !this.dataAddresses[1].city_code) {
            this.errors.push('cityFact');
            this.errors.push('укажите город');
            return false
          } else if (!this.str.cyrillicAndNums.test(this.dataAddresses[1].city)) {
            this.errors.push('cityFact');
            this.errors.push('допустимы только символы кириллицы');
            return false
          } else if (!this.dataAddresses[1].street) {
            this.errors.push('streetFact');
            this.errors.push('укажите улицу');
            return false
          } else if (!this.str.cyrillicAndNums.test(this.dataAddresses[1].street)) {
            this.errors.push('streetFact');
            this.errors.push('допустимы только символы кириллицы');
            return false
          } else if (!this.dataAddresses[1].house) {
            this.errors.push('houseFact');
            this.errors.push('укажите дом');
            return false
          }
        }
      }
      // Выгодоприобретатели
      if (this.dataAgreement.beneficiaries.length > 0) {
        for (let index in this.dataAgreement.beneficiaries) {
          if (false) {
            return false
          } else if (!this.dataContacts[parseInt(index) + 1].last_name) {
            this.errors.push('last_name' + index);
            this.errors.push('укажите фамилию');
            return false
          } else if (!this.str.cyrillic.test(this.dataContacts[parseInt(index) + 1].last_name)) {
            this.errors.push('last_name' + index);
            this.errors.push('допустимы только символы кириллицы');
            return false
          } else if (!this.dataContacts[parseInt(index) + 1].first_name) {
            this.errors.push('first_name' + index);
            this.errors.push('укажите имя');
            return false
          } else if (!this.str.cyrillic.test(this.dataContacts[parseInt(index) + 1].first_name)) {
            this.errors.push('first_name' + index);
            this.errors.push('допустимы только символы кириллицы');
            return false
          } else if (this.dataContacts[parseInt(index) + 1].middle_name
              && !this.str.cyrillic.test(this.dataContacts[parseInt(index) + 1].middle_name)) {
            this.errors.push('middle_name' + index);
            this.errors.push('допустимы только символы кириллицы');
            return false
          } else if (!this.dataContacts[parseInt(index) + 1].birth_date) {
            this.errors.push('birthDate' + index);
            this.errors.push('укажите дату рождения');
            return false
          } else if (this.dataAgreement.beneficiaries[index].relationship && !this.str.cyrillicAndNums.test(this.dataAgreement.beneficiaries[index].relationship)) {
            this.errors.push('relationship' + index);
            this.errors.push('допустимы только символы кириллицы');
            return false
          } else if (!this.dataAddresses[parseInt(index) + 2].addresses) {
            this.errors.push('address' + index);
            this.errors.push('укажите адрес регистрации');
            return false
          } else if (!this.str.cyrillicAndNums.test(this.dataAddresses[parseInt(index) + 2].addresses)) {
            this.errors.push('address' + index);
            this.errors.push('допустимы только символы кириллицы');
            return false
          } else if (!this.dataAgreement.beneficiaries[index].part) {
            this.errors.push('part' + index);
            this.errors.push('укажите долю от страховой суммы');
            return false
          } else if (this.checkShares() !== 'ok') {
            if (this.checkShares() === 'excess') {
              this.errors.push('part');
              this.errors.push('сумма долей превышает 100%');
            } else if (this.checkShares() === 'lack') {
              this.errors.push('part');
              this.errors.push('сумма долей менее 100%');
            }
            return false
          }
        }
      }
      return true
    },
    // запросы до госуслуг
    requestInterval() {
      setInterval(() => {
        this.frontValidate();
      }, 2000);
      setInterval(() => {
        if (this.bool.requestAvailable && this.bool.requestArrived) {
          this.bool.requestAvailable = false;
          this.bool.requestArrived = false;
          this.backValidateAndGetKid();
          this.getRules();
        }
      }, 5000);
    },
    // async getContractAmount() {
    //   try {
    //
    //     const request = {
    //       sessionToken: this.str.sessionToken,
    //       format: "json",
    //       ver: 2,
    //       object: "contract",
    //       login: "sravni",
    //       action: "calc",
    //       agreement: {
    //         program: "gp",
    //         ins_calc_amount: this.dataAgreement.ins_calc_amount,
    //         ins_calc_type: this.dataAgreement.ins_calc_type,
    //         ins_period: this.dataAgreement.ins_period,
    //         payment_order: this.dataAgreement.payment_order,
    //         currency: this.dataAgreement.currency,
    //         insurer_birth_date: this.dataContacts[0].birth_date,
    //         insured_birth_date: this.dataContacts[0].birth_date,
    //         insurer_sex: this.dataContacts[0].sex,
    //         insured_sex: this.dataContacts[0].sex,
    //         menu_id: this.dataAgreement.menu_id,
    //         variant_id: this.dataAgreement.variant_id,
    //         variant_type: this.dataAgreement.variant_type
    //       }
    //     };
    //     const response = await axios.post(baseURL, request);
    //     const r_data = response.data;
    //
    //     if (r_data.ins_sum) {
    //       this.str.contractAmount = r_data.ins_sum;
    //     } else {
    //       this.str.contractAmount = '-1';
    //     }
    //   } catch (e) {
    //     console.log('Frontend Error - ' + e)
    //   } finally {
    //   }
    // },
    async getKladr(val, queryType, cityCode) {
      try {
        let request;
        let query;
        if (queryType === 'birth_place' || queryType === 'cityReg' || queryType === 'cityFact') {
          query = 'city';
          request = {
            sessionToken: this.str.sessionToken,
            action: "kladrlife",
            login: "sravni",
            kladr: {
              term: val,
              type: query
            },
          }
        } else if (queryType === 'streetReg' || queryType === 'streetFact') {
          query = 'street';
          request = {
            sessionToken: this.str.sessionToken,
            action: "kladrlife",
            login: "sravni",
            kladr: {
              term: val,
              type: query,
              city_code: cityCode
            },
          }
        }
        const response = await axios.post(baseURL, request);
        const r_data = response.data;

        if (r_data.state === "success" && r_data.kladr.length > 0) {
          if (queryType === 'cityReg') {
            this.optionsCityReg = r_data.kladr;
          } else if (queryType === 'streetReg') {
            this.optionsStreetReg = r_data.kladr;
          } else if (queryType === 'cityFact') {
            this.optionsCityFact = r_data.kladr;
          } else if (queryType === 'streetFact') {
            this.optionsStreetFact = r_data.kladr;
          }
        }
      } catch (e) {
        console.log('Frontend Error - ' + e);
      } finally {
      }
    },
    async getRules() {
      try {
        const request = {
          sessionToken: this.str.sessionToken,
          action: "get_rule",
          format: "json",
          ver: "2",
          object: "contract",
          login: "sravni",
          type: '12',
        }
        const response = await axios.post(baseURL, request);
        const r_data = response.data;

        if (r_data.state === 'success') {
          const urlRules = r_data.rules;
          this.str.rulesLink = urlRules;
        } else {
          this.errors.push('backendError');
          this.errors.push(r_data);
          this.bool.showDialog = false;
          this.str.errorDialogType = 'server_fail';
          this.bool.showErrorDialog = true;
          this.errorLogger(r_data);
          console.log('backend error after getRules request');
        }
      } catch (e) {
        console.log('Frontend Error - ' + e);
      } finally {
      }
    },
    async backValidateAndGetKid() {
      try {
        this.bool.newKidArrived = false;

        const request = {
          sessionToken: this.str.sessionToken,
          action: "check",
          format: "json",
          ver: 2,
          object: "contract",
          login: "sravni",
          agreement: JSON.parse(JSON.stringify(this.dataAgreement)),
          documents: JSON.parse(JSON.stringify(this.dataDocuments)),
          addresses: JSON.parse(JSON.stringify(this.dataAddresses)),
          contacts: JSON.parse(JSON.stringify(this.dataContacts))
        };
        this.reworkData(request);
        const response = await axios.post(baseURL, request);
        const r_data = response.data;
        if (r_data.error_code === 4140) {
          const domain = localDevelopment || testDevelopment ? `https://${subdomain}.makclife.ru` : "https://makclife.ru";
          
          const urlKid = r_data.error.use.named_params_kid_signed.link;
          const urlPolicy = r_data.error.use.named_params_kid_signed.policy.link;

          this.str.kidLink = domain + urlKid;
          this.str.policyLink = domain + urlPolicy;
          this.bool.newKidArrived = true;
        } else {
          this.errors.push('backendError');
          this.errors.push(r_data);

          this.bool.showDialog = false;
          this.str.errorDialogType = 'server_fail';
          this.bool.showErrorDialog = true;

          this.errorLogger(r_data);

          console.log('backend error after Kid request');
        }
      } catch (e) {
        console.log('Frontend Error - ' + e);
      } finally {
        this.bool.requestArrived = true
      }
    },
    async openGosuslugi() {
      try {
        this.bool.showDialog = true;
        const currentUrl = "https://" + window.location.host + "/policy";
        const fieldsToGetBack = {
          sessionToken: this.str.sessionToken,
          agreement: JSON.parse(JSON.stringify(this.dataAgreement)),
          documents: JSON.parse(JSON.stringify(this.dataDocuments)),
          addresses: JSON.parse(JSON.stringify(this.dataAddresses)),
          contacts: JSON.parse(JSON.stringify(this.dataContacts))
        };

        let dateFull = new Date(this.dataDocuments[0].date);
        let date = dateFull.getDate();
        if (parseInt(date) < 10) {
          date = '0' + date
        }
        let month = dateFull.getMonth() + 1;
        if (parseInt(month) < 10) {
          month = '0' + month
        }
        let newDate = date + '.' + month + '.' + dateFull.getFullYear();

        const request = {
          sessionToken: this.sessionToken,
          format: "json",
          ver: 2,
          action: "esia_url",
          login: "sravni",
          redirect_url: currentUrl,
          data: fieldsToGetBack,
          first_name: this.dataContacts[0].first_name,
          middle_name: this.dataContacts[0].middle_name,
          last_name: this.dataContacts[0].last_name,
          serial: this.dataDocuments[0].serial,
          number: this.dataDocuments[0].number,
          date: newDate
        }
        const response = await axios.post(baseURL, request);
        const r_data = response.data;

        if (r_data.state === 'success') {
          window.open(r_data.esia_link, '_self')
        } else {
          this.errors.push('backendError');
          this.errors.push(r_data);
          this.str.errorDialogType = 'server_fail';
          this.bool.showErrorDialog = true;
          this.errorLogger(r_data);
          console.log('backend error after openGosuslugi request');
        }
      } catch (e) {
        console.log('Frontend Error - ' + e);
      } finally {
      }
    },
    // запросы после госуслуг
    async checkGosuslugi() {
      try {
        /// (Проверка
        let queryString = window.location.search;
        let urlParams = new URLSearchParams(queryString);
        let MyCode;
        let MyState;
        if (!urlParams.has('code') || !urlParams.has('state')) {
          this.str.sessionToken = new Date;
          return
        }
        /// Проверка)
        this.bool.previewPassed = true;
        MyCode = urlParams.get('code');
        MyState = urlParams.get('state');
        this.bool.showDialog = true;
        const request = {
          format: "json",
          ver: 2,
          action: "esia_get_data_check_value",
          login: "sravni",
          code: MyCode,
          state: MyState,
        }
        const response = await axios.post(baseURL, request);
        const r_data = response.data;

        const oldFields = response.data.data;
        this.str.sessionToken = oldFields.sessiontoken;
        this.dataAgreement = oldFields.agreement;
        this.dataDocuments = oldFields.documents;
        this.dataAddresses = oldFields.addresses;
        this.dataContacts = oldFields.contacts;
        this.dataAgreement.beneficiaries = this.dataAgreement.beneficiaries ? this.dataAgreement.beneficiaries : [];

        const gosuslugiErrors = Object.entries(r_data.error_coincidence);
        if (gosuslugiErrors.length === 0) {
          this.fetchContract();
        } else if (gosuslugiErrors.length > 0) {
          for (let [key, value] of gosuslugiErrors) {
            if (key === 'last_name' || key === 'first_name' || key === 'middle_name') {
              this.dataContacts[0].key = value;
            } else if (key === 'serial' || key === 'number' || key === 'date') {
              this.dataDocuments[0].key = value
            }
          }
          this.erroredFields = Object.keys(r_data.error_coincidence);

          this.bool.showDialog = false;
          this.str.errorDialogType = 'gosuslugi_fail';
          this.bool.showErrorDialog = true;
          this.bool.showInlineAlert = true;
        }
      } catch (e) {
        console.log('Frontend Error - ' + e);
      } finally {
        this.bool.requestArrived = true;
        this.requestInterval();
      }
    },
    async fetchContract() {
      try {
        this.bool.requestArrived = false;

        const response = await axios.post(baseURL, this.kidSignedRequest);
        const r_data = response.data;

        if (r_data.state === 'success') {
          this.str.contractId = r_data.id;

          this.str.step = 'confirm'
          this.fetchCode();
        } else if (r_data.error.use.insurer_doc_date) {
          this.bool.showDialog = false;
          this.erroredFields.push('date');

          this.confirmationError(['doc_date', r_data.error.use.insurer_doc_date[0].error]);

          console.log('doc_date error after fetchContract request');
        } else {
          this.bool.showDialog = false;

          this.errors.push('backendError');
          this.errors.push(r_data);
          this.str.errorDialogType = 'server_fail';
          this.bool.showErrorDialog = true;

          console.log('backend error after fetchContract request');
        }
      } catch (e) {
        console.log('Frontend Error - ' + e);
      } finally {
        this.bool.requestArrived = true;
      }
    },
    async fetchCode() {
      try {
        console.log('fetchCode request to ' + this.kidSignedRequest.contacts[0].phone);
        const request = {
          sessionToken: this.str.sessionToken,
          format: "json",
          ver: 2,
          action: "generatesigncheckcode",
          code_sign: "contact",
          id_sign: this.str.contractId,
          phone: this.kidSignedRequest.contacts[0].phone,
          methods: "SMS"
        }
        const response = await axios.post(baseURL, request);
        const r_data = response.data;

        if (r_data.state === 'error') {
          this.str.msgAlert = r_data.msg;
        } else if (r_data.state === 'success') {
          this.str.msgAlert = 'Код отправлен на указанный номер'
        }
      } catch (e) {
        console.log('Frontend Error - ' + e);
      } finally {
      }
    },
    async checkNumbers() {
      try {
        this.str.codeCheckAvbl = false;
        this.str.msgAlert = '';
        console.log('checkNumbers request by ' + this.str.numbers);

        const request = {
          sessionToken: this.str.sessionToken,
          format: "json",
          ver: 2,
          action: "comparesigncheckcode",
          check_sign: this.str.numbers,
          code_sign: "contact",
          id_sign: this.str.contractId
        }
        const response = await axios.post(baseURL, request);
        const r_data = response.data;

        if (r_data.state === 'success') {
          this.openPaylink();
        } else if (r_data.state === 'error') {
          this.str.msgAlert = 'Введен неверный код';

          console.log("r_data.msg - " + r_data.msg);
        }
      } catch (e) {
        console.log('Frontend Error - ' + e);
      } finally {
      }
    },
    async openPaylink() {
      try {
        this.str.step = 'loader';
        const request = {
          sessionToken: this.str.sessionToken,
          format: "json",
          ver: 2,
          action: "creatpay",
          login: "sravni",
          policy_id: this.str.contractId,
          phone: this.kidSignedRequest.contacts[0].phone,
          email: this.kidSignedRequest.contacts[0].email
        }
        const response = await axios.post(baseURL, request);
        const r_data = response.data;

        if (r_data.state === 'success' && r_data.url !== false) {
          const paylink = r_data.url.link;
          window.open(paylink, '_self')
        } else {
          this.errors.push('backendError');
          this.errors.push(r_data);

          this.bool.showDialog = false;
          this.str.errorDialogType = 'server_fail';
          this.bool.showErrorDialog = true;

          this.errorLogger(r_data);

          console.log('backend error after getPayLink request');
        }
      } catch (e) {
        console.log('Frontend Error - ' + e);
      } finally {
      }
    },

    async errorLogger(error) {
      try {
        console.log('error log sending');
        const request = {
          sessionToken: this.str.sessionToken,
          action: "logger",
          login: "sravni",
          data: error
        }

        const response = await axios.post(baseURL, request);

        console.log('error log response' + response.data);
      } catch (e) {
      } finally {
      }
    },
    // работа с данными
    reworkData(obj) {
      const reworkDocNumber = (docNumber) => {
        let doc = docNumber.length === 0 ? '555-555' : docNumber;

        const nums = /([0-9])/g;
        let result = doc.match(nums).join('');

        return result
      }
      const reworkDate = (dateNumber) => {
        let date = dateNumber.length === 0 ? '2022-02-24' : dateNumber;

        const result = date.split("-").reverse().join(".");
        return result
      }
      const reworkPhone = (phoneNumber) => {
        let phone = phoneNumber.length === 0 ? '+7(985)555-55-55' : phoneNumber;

        const nums = /([0-9]|[+])/g;
        let result = phone.match(nums).join('');

        return result
      }

      obj.documents[0].number = reworkDocNumber(this.dataDocuments[0].number);
      obj.documents[0].date = reworkDate(this.dataDocuments[0].date);
      obj.contacts[0].phone = reworkPhone(this.dataContacts[0].phone);

      if (obj.contacts.length > 1) {
        for (let item of obj.contacts) {
          item.birth_date = reworkDate(item.birth_date);
        }
      } else {
        obj.contacts[0].birth_date = reworkDate(this.dataContacts[0].birth_date);
      }
    },
    getTodaysDate() {
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0');
      var yyyy = today.getFullYear();
      today = yyyy + '-' + mm + '-' + dd;
      return today;
    },
    getAge(dateString) {
      let today = new Date();
      let birthDate = new Date(dateString);

      let age = today.getFullYear() - birthDate.getFullYear();
      let m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;
    },
    spaceNumsAddRouble(nums) {
      return nums.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + ' руб.';
    },
    checkDocDate() {
      if ((this.getAge(this.dataContacts[0].birth_date) - this.getAge(this.dataDocuments[0].date)) < 14) {
        return false
      } else {
        return true
      }
    },
    // действия и ошибки
    numbersInserted(numbers) {
      this.str.numbers = numbers;
      this.bool.codeCheckAvbl = true;
    },
    confirmationError(arr) {
      this.errors = arr;
      this.bool.requestAvailable = false;

      if (arr[0] === 'doc_date') {
        this.bool.requestArrived = false;
        this.$refs.doc_date.focus();
      } else {
        this.errorLogger(arr[1]);
        this.str.errorDialogType = 'server_fail';
        this.bool.showErrorDialog = true;
      }

    },
    toggleFactAddress() {
      if (this.dataContacts[0].addresses[1] === '0') {
        this.bool.factAddressIsRegAddress = false;

        this.dataContacts[0].addresses[1] = '1';
      } else {
        this.bool.factAddressIsRegAddress = true;

        this.dataContacts[0].addresses[1] = '0'

        this.dataAddresses[1].city = '';
        this.dataAddresses[1].city_code = '';
        this.dataAddresses[1].street = '';
        this.dataAddresses[1].street_code = '';
      }
    },
    toggleBeneficiaries() {
      if (this.dataAgreement.beneficiaries.length === 0) {
        this.bool.heirsAreBeneficiaries = false;

        this.addBeneficiary();
      } else {
        this.bool.heirsAreBeneficiaries = true;

        this.dataAgreement.beneficiaries = [];
        this.dataAddresses = this.dataAddresses.slice(0, 2);
        this.dataContacts = this.dataContacts.slice(0, 1);
      }
    },
    addBeneficiary() {
      const beneficiary = {
        contact: this.dataAgreement.beneficiaries.length + 1,
        part: '',
        relationship: '',
      };
      const address = {
        addresses: ""
      };
      const contact = {
        first_name: "",
        middle_name: "",
        last_name: "",
        birth_date: "",
        addresses: [this.dataAddresses.length],
      };
      this.dataAgreement.beneficiaries.push(beneficiary);
      this.dataAddresses.push(address);
      this.dataContacts.push(contact);
    },
    removeBeneficiary() {
      if (this.dataAgreement.beneficiaries.length == 1) {
        this.toggleBeneficiaries()
      } else {
        this.dataAgreement.beneficiaries.pop();
        this.dataAddresses.pop();
        this.dataContacts.pop();
      }
    },
    checkShares() {
      const benefs = JSON.parse(JSON.stringify(this.dataAgreement.beneficiaries));
      if (benefs.length > 0) {
        let share = 0;
        for (let item of benefs) {
          if (item.part) {
            share += parseInt(item.part);
          }
        }
        if (share > 100) {
          return 'excess';
          // this.errors.push('part');
          // this.errors.push('сумма долей превышает 100%');
        } else if (share < 100) {
          return 'lack';
          // this.errors.push('part');
          // this.errors.push('сумма долей менее 100%');
        } else {
          return 'ok';
        }
      }
    },
  },
  watch: {
    watchedDataFields: {
      handler(val) {
        this.bool.newKidArrived = false;
        this.arr.markedCheckboxes = [];
        this.checkbox_user_agreement = false;

        if (this.frontValidate()) {
          this.bool.requestAvailable = true
        } else {
          this.bool.requestAvailable = false
        }
      },
      deep: true
    },
    queryCityReg(val) {
      this.errors = [];

      if (val.length === 0) {
        this.optionsCityReg = [];
        this.bool.newKidArrived = false;
        this.errors.push('cityReg');
        this.errors.push('укажите город');
      } else if (!this.str.cyrillicAndNums.test(val)) {
        this.errors.push('cityReg');
        this.errors.push('допустимы только символы кириллицы');
      } else {
        this.errors = [];
        this.getKladr(val, 'cityReg');
      }
    },
    queryStreetReg(val) {
      if (this.dataAddresses[0].city_code === '' && val.length > 0) {
        this.errors = [];
        this.errors.push('street');
        this.errors.push('сначала выберите город');
      } else if (val.length === 0) {
        this.optionsStreetReg = [];
        this.bool.newKidArrived = false;
        this.errors.push('streetReg');
        this.errors.push('укажите улицу');
      } else if (!this.str.cyrillicAndNums.test(val)) {
        this.errors = [];
        this.errors.push('streetReg');
        this.errors.push('допустимы только символы кириллицы');
      } else {
        this.errors = [];
        this.getKladr(val, 'streetReg', this.dataAddresses[0].city_code);
      }
    },
    queryCityFact(val) {
      this.errors = [];
      if (val.length === 0) {
        this.optionsCityFact = [];
        this.bool.newKidArrived = false;
        this.errors.push('cityFact');
        this.errors.push('укажите город');
      } else if (!this.str.cyrillicAndNums.test(val)) {
        this.errors.push('cityFact');
        this.errors.push('допустимы только символы кириллицы');
      } else {
        this.errors = [];
        this.getKladr(val, 'cityFact');
      }
    },
    queryStreetFact(val) {
      this.errors = [];
      if (!this.dataAddresses[1].city_code && val.length > 0) {
        this.errors.push('street');
        this.errors.push('сначала выберите город');
      } else if (val.length === 0) {
        this.optionsStreetFact = [];
        this.bool.newKidArrived = false;
        this.errors.push('streetFact');
        this.errors.push('укажите улицу');
      } else if (!this.str.cyrillicAndNums.test(val)) {
        this.errors = [];
        this.errors.push('streetFact');
        this.errors.push('допустимы только символы кириллицы');
      } else {
        this.errors = [];
        this.getKladr(val, 'streetFact', this.dataAddresses[1].city_code);
      }
    }
  },
  computed: {
    insContractParameters() {
      return `${this.dataContacts[0].birth_date}|${this.dataContacts[0].sex}|${this.dataAgreement.ins_period}|${this.dataAgreement.ins_calc_amount}`;
    },
    kidSignedRequest() {
      const request = {
        sessionToken: this.str.sessionToken,
        action: "create",
        format: "json",
        ver: 2,
        object: "contract",
        login: "sravni",
        agreement: JSON.parse(JSON.stringify(this.dataAgreement)),
        documents: JSON.parse(JSON.stringify(this.dataDocuments)),
        addresses: JSON.parse(JSON.stringify(this.dataAddresses)),
        contacts: JSON.parse(JSON.stringify(this.dataContacts))
      };
      request.agreement.named_params = {kid_signed: 'Y'};
      this.reworkData(request);
      return request;
    },
    watchedDataFields() {
      const copyFields = {
        agreement: JSON.parse(JSON.stringify(this.dataAgreement)),
        documents: JSON.parse(JSON.stringify(this.dataDocuments)),
        addresses: JSON.parse(JSON.stringify(this.dataAddresses)),
        contacts: JSON.parse(JSON.stringify(this.dataContacts))
      }
      return copyFields;
    },

    // queryBirthPlace() {
    //     const copyContacts = JSON.parse(JSON.stringify(this.dataContacts));
    //     return copyContacts[0].birth_place;
    // },
    queryCityReg() {
      const copyAddresses = JSON.parse(JSON.stringify(this.dataAddresses));
      return copyAddresses[0].city;
    },
    queryStreetReg() {
      const copyAddresses = JSON.parse(JSON.stringify(this.dataAddresses));
      return copyAddresses[0].street;
    },
    queryCityFact() {
      const copyAddresses = JSON.parse(JSON.stringify(this.dataAddresses));
      return copyAddresses[1].city;
    },
    queryStreetFact() {
      const copyAddresses = JSON.parse(JSON.stringify(this.dataAddresses));
      return copyAddresses[1].street;
    },
  },
  created() {
    this.checkGosuslugi();
  },
}
</script>

<style scoped lang="scss">

@import "@/create/assets/scss/style.scss";

</style>
